import { merge, delay } from 'rxjs';
import { map } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { RouterAction } from '@cbridge-packages/routing';
import { SpreadProfileAction } from '@cbridge-packages/spread-profile';
import { generateSpreadProfileRoute } from '@cbridge-packages/routing-client-admin';

export const toggleViewSpreadProfileSidebarEpic: IEpic = (action$) => merge(
  action$.pipe(
    isTypeOfAndGetPayload(SpreadProfileAction.create.done),
    delay(100),
    map(({ result }) => RouterAction.replace([generateSpreadProfileRoute(result.id)])),
  ),
  action$.pipe(
    isTypeOfAndGetPayload(SpreadProfileAction.update.done),
    map(({ params }) => RouterAction.replace([generateSpreadProfileRoute(params.id)])),
  ),
);
